import React from "react";
import { useNavigate } from "react-router-dom";
import "./FeaturedRegions.css";

const FeaturedRegions = () => {
  const navigate = useNavigate();

  const regions = [
    {
      id: "india",
      title: "Incredible India 🇮🇳",
      image: "/india-cover.jpg",
      description:
        "Explore the majestic beauty, history, and culture of India.",
    },
    {
      id: "asia",
      title: "Explore Asia ",
      image: "/asia-cover.jpg",
      description:
        "From tropical islands to futuristic cities, Asia awaits you.",
    },
    {
      id: "europe",
      title: "Discover Europe 🇪🇺",
      image: "/europe-cover.jpg",
      description:
        "Experience timeless charm, architecture, and scenic landscapes.",
    },
  ];

  return (
    <section className="featured-regions-section">
      <h2 className="section-title">🌍 Featured Destinations</h2>
      <div className="region-card-container">
        {regions.map((region) => (
          <div
            key={region.id}
            className="region-card"
            onClick={() => navigate(`/destinations/${region.id}`)}
          >
            <img src={region.image} alt={region.title} />
            <div className="overlay">
              <h3>{region.title}</h3>
              <p>{region.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FeaturedRegions;
